/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Box, FormControl, InputLabel } from "@mui/material";
import { MRT_TableInstance } from "material-react-table";
import ArgosMenuItem from "../../../../../components/Form/Select/ArgosMenuItem";
import ArgosSelect from "../../../../../components/Form/Select/ArgosSelect";
import {AdasProgramsReportPages, ReportsTableData} from "../constants";
import { Dispatch } from "react";


interface LeftToolbarActionsProps {
  page: AdasProgramsReportPages
  setSelectedMergeConfiguration: Dispatch<React.SetStateAction<string>>
  selectedMergeConfiguration: string
  mergeConfigurations: string[]
}

export const LeftToolbarActions = (table: MRT_TableInstance<ReportsTableData>, props: LeftToolbarActionsProps) => {
  const { page, setSelectedMergeConfiguration, selectedMergeConfiguration, mergeConfigurations } = props

  let filterLabel: string = ''
  switch (page) {
    case AdasProgramsReportPages.SENSING_SYSTEM_REQUIREMENT:
      filterLabel = 'Merge Configuration'
      break
    case AdasProgramsReportPages.SENSOR_COMPONENT_REQUIREMENT:
      filterLabel = 'Sensor Name and Location'
      break
    case AdasProgramsReportPages.WORLD_MODEL_SOLUTION_REQUIREMENT:
      filterLabel = 'Merge Configuration'
      break
    default:
      filterLabel = ''
  }


  return (
    <Box alignItems='center' style={{display: 'flex'}}>
      <FormControl variant="standard">
        <InputLabel id='table-filter-label'>{filterLabel}</InputLabel>
        <ArgosSelect
          labelId='table-filter-label'
          id='table-filter'
          onChange={(e) => {
            setSelectedMergeConfiguration(e.target.value as string)
          }}
          value={selectedMergeConfiguration}
        >
          <ArgosMenuItem value={'All'}>All</ArgosMenuItem>
          {mergeConfigurations?.map((mergeConfiguration: string) => {
            return (
              <ArgosMenuItem value={mergeConfiguration}>{mergeConfiguration}</ArgosMenuItem>
            )
          })}
        </ArgosSelect>
      </FormControl>
    </Box>
  )
}
